import React from 'react';
import {Redirect} from 'react-router';
import api from "../../../api/Api";
import withStyles from "@material-ui/core/styles/withStyles";
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import ClinicTimingsEdit from "components/Forms/ClinicForm/updateTimings.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import CardFooter from "components/Card/CardFooter.jsx";
import TagInputAutoSuggest from "components/Forms/ClinicForm/TagInputAutoSuggest.jsx";
import ClinicTimings from "components/Forms/ClinicForm/addTimings.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {NavLink} from 'react-router-dom';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from '../../../components/Loader';

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Icon from '@material-ui/core/Icon';
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum, verifyUrl,
    verifyNumber, verifyPincode, dashboardRouter,
    verifyPhoneNumber, isClinicMasterOrClinic, getClinicUserId, clinicmaster_id
} from '../../../util/globalHelper'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nameState: "",
            last_nameState: "",
            name: "",
            last_name: "",
            specialities: [],
            timings: [],
            phoneNumberState: "",
            phoneNumber: "", descriptionState: "",
            description: "",
            mciNumber: "",
            mciNumberState: "",
            alert: null,
            open: true,
            experience: "",
            experienceState: "",
            qualification: "",
            qualificationState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            imageurl: "",
            registerEmail: "",
            registerEmailState: "",
            gender: "male",
            genderState: "",
            redirect: false,
            simpleSelect: "",
            role: "doctor",
            roleClinic: "doctor_clinic",
            timingsadded: false,
            selectedValue: null,
            services: [],
            clinic_id: "",
            online:"false",
            clinicmaster_id: "",
            signature: "",
            signatureState: "",
            clinic_name: "",
            generateddoctor_id: "",
            showDropdown: false,
            clinicsData: null,
            validation: null,
            editorState: EditorState.createEmpty(),


        };
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this);
        this.CreateAlertForEdit = this.CreateAlertForEdit.bind(this);
        this.CreateAlertonADD = this.CreateAlertonADD.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
        this.handleChangeGender = this.handleChangeGender.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this)
    }


    CreateAlertonADD(reason) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{reason}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideAlert}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    onEditorStateChange(editorState) {
        this.setState({
            editorState,
        });
    };

    handleChangeServices(services) {
        this.setState({
            services: services.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        });
    }

    handleChangeSpecialities(specialities) {
        this.setState({
            specialities: specialities.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        });
    }

    handleTimings(timings) {
        this.setState({timings});
        this.setState({timingsadded: true});
    }

    handleImageUrl(url) {
        this.setState({imageurl: url});
    }

    CreateAlertForEdit() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"><ClinicTimingsEdit
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)} hideAlert={this.hideAlert.bind(this)}
                        timings={this.state.timings}/></DialogTitle>
                </Dialog>
            )
        });
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        if (stateName === "username" && this.state.username.length > 3 && this.state.usernameState === "success") {
            api.validateUser({"username": event.target.value}).then(json => {
                this.setState({validation: json.data.data.valid})
            })
        }
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                }
                else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    CreateAlert() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"><ClinicTimings
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)}
                        hideAlert={this.hideAlert.bind(this) }/></DialogTitle>
                </Dialog>
            )
        });
    }

    CallCreateApi(data) {
        api.createDoctor(data).then(json => {
            if (json.data.isError) {
                var msgcolor = {message: json.data.message.message, color: "danger"};
                this.props.id.generateNotification(msgcolor);
            } else {
                this.setState({redirect: true});
                var msgcolor = {message: "Doctor Added Successfully!", color: "success"};
                this.props.id.generateNotification(msgcolor);
                this.props.id.history.push(dashboardRouter(`/doctor/oneDoctor/${json.data.data._id}`))
            }
        }).catch(error => {
            var msgcolor = {message: "Server Error!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        })
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    componentDidMount() {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}, clinicmaster_id: clinicmaster_id()});
        this.props.id.match.params.clinicmasterID ?
            this.setState({
                clinicmaster_id: this.props.id.match.params.clinicmasterID,
                clinic_id: this.props.id.match.params.clinicID,
            }) : this.setState({showDropdown: true})
    }

    handleChangeGender(event) {
        this.setState({
            gender: event.target.value
        });
    }

    setGender(event) {
        this.setState({gender: event.target.value})
    }

    typeClick() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please fill the name!", color: "danger"});

        }
        else if (this.state.registerEmailState === "") {
            this.setState({registerEmailState: "error"});
            this.props.id.generateNotification({message: "Please fill the email!", color: "danger"});
        }
        else if (this.state.phoneNumber === "") {
            this.setState({phoneNumberState: "error"});
            this.props.id.generateNotification({message: "Please fill the number!", color: "danger"});

        }
        else if (this.state.nameState === "success" &&
            // this.state.last_nameState === "success" &&
            this.state.phoneNumberState === "success" &&
            this.state.mciNumberState !== "error" &&
            this.state.registerEmailState !== "error" && this.state.experienceState !== "error" && this.state.qualificationState !== "error") {
            var clinicsobject = {
                "timings": this.state.timings,
                "services": this.state.services,
                "clinic_id": this.state.clinic_id,
                "clinic_name": this.state.clinic_name,
                "signature": this.state.signature,

            }
            var data = {
                speciality: this.state.specialities,
                name: this.state.name,
                // last_name: this.state.last_name,
                contact: this.state.phoneNumber,
                mci_number: this.state.mciNumber,
                experience: this.state.experience,
                qualification: this.state.qualification,
                profile_image: this.state.imageurl,
                email: this.state.registerEmail,
                username: this.state.username,
                password: this.state.password,
                gender: this.state.gender,
                clinics: [clinicsobject],
                clinic_id: this.state.clinic_id,
                online_consultations_provided:JSON.parse(this.state.online),
                clinic_master_id: this.state.clinicmaster_id,
                display_name: "Dr. " + this.state.name,
                description: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
            };
            this.CallCreateApi(data);
            // this.CallTagMasterSpecialities();
            // this.CallTagMasterServices();
        }
        else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    render() {
        if((!this.props.id.match.params.clinicmasterID && this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0] !== null && this.state.clinicsData === [])) { this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id) }

        const {classes} = this.props;
        const {clinicMasterList, clinicsData, editorState} = this.state;
        if (this.state.clinicMasterList)
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <form>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Name"
                                            id="name"
                                            success={this.state.nameState === "success"}
                                            error={this.state.nameState === "error"}
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "name", "name", "required")
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            success={this.state.registerEmailState === "success"}
                                            error={this.state.registerEmailState === "error"}
                                            labelText="Email "
                                            id="registeremail"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "registerEmail", "email", "optional"),
                                                type: "email"
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Username"
                                            success={this.state.usernameState === "success"}
                                            error={this.state.usernameState === "error"}
                                            id="username"
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "username", "alphanum")
                                            }}
                                        />
                                        <small>{this.state.validation === true ? "Username available" : this.state.validation === false ? "Username not avalibale" : null}</small>

                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Password"
                                            success={this.state.passwordState === "success"}
                                            error={this.state.passwordState === "error"}
                                            id="password"
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "password", "alphanum"),
                                                type: "password"

                                            }}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Phone Number"
                                            success={this.state.phoneNumberState === "success"}
                                            error={this.state.phoneNumberState === "error"}
                                            id="phonenumber"
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "phoneNumber", "phonenumber", "required")
                                            }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="MCI Number"
                                            success={this.state.mciNumberState === "success"}
                                            error={this.state.mciNumberState === "error"}
                                            id="mci"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "mciNumber", "alphanum", "optional")
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Qualification"
                                            success={this.state.qualificationState === "success"}
                                            error={this.state.qualificationState === "error"}
                                            id="mci"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "qualification", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Experience"
                                            success={this.state.experienceState === "success"}
                                            error={this.state.experienceState === "error"}
                                            id="experience"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "experience", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <div style={{minHeight: '100px'}}>
                                            <legend>Description</legend>
                                            <Editor
                                                editorState={editorState}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                onEditorStateChange={this.onEditorStateChange}
                                            />
                                            <br />
                                        </div>
                                        {/*<CustomInput*/}
                                        {/*labelText="Description"*/}
                                        {/*success={this.state.descriptionState === "success"}*/}
                                        {/*error={this.state.descriptionState === "error"}*/}
                                        {/*id="mci"*/}
                                        {/*formControlProps={{*/}
                                        {/*fullWidth: true*/}
                                        {/*}}*/}
                                        {/*inputProps={{*/}
                                        {/*onChange: event =>*/}
                                        {/*this.change(event, "description", "novalidation", "optional")*/}
                                        {/*}}*/}
                                        {/*/>*/}
                                    </GridItem>


                                    <GridItem xs={12} sm={6} md={6}>
                                        <legend>Image:</legend>
                                        <ImageUpload
                                            addButtonProps={{
                                                color: "warning",
                                                round: false
                                            }}
                                            changeButtonProps={{
                                                color: "warning",
                                                round: false
                                            }}
                                            removeButtonProps={{
                                                color: "grey",
                                                round: false
                                            }}
                                            handleImageUrl={this.handleImageUrl.bind(this)}
                                            role="Doctor"
                                        />
                                    </GridItem>


                                    <GridItem xs={12} sm={6} md={6}>
                                        <legend>Gender</legend>
                                        {/*<p><b>Gender:</b></p>
                                        */}<RadioGroup aria-label="position" name="position" value={this.state.gender}
                                                    onChange={this.handleChangeGender} row>
                                            <FormControlLabel
                                                value="M"
                                                control={<Radio color="primary"/>}
                                                label="Male"
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="F"
                                                control={<Radio color="primary"/>}
                                                label="Female"
                                                labelPlacement="end"
                                            />
                                        </RadioGroup>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <legend>Specialities</legend>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <TagInputAutoSuggest
                                                handleChangeSpecialities={this.handleChangeSpecialities.bind(this)}
                                                specialities={this.state.specialities} role={this.state.role}
                                                tagname={"speciality"}/>
                                        </GridItem>
                                    </GridItem>


                                    <GridContainer style={{padding: "0px 20px"}}>
                                        <GridItem xs={12} sm={6} md={6}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={4}>
                                                    <legend>Timings</legend>
                                                </GridItem>
                                                {this.state.timingsadded ? (
                                                    <GridItem xs={12} sm={12} md={8}>
                                                        <GridContainer>
                                                            <GridItem xs={12} sm={6} md={6}>
                                                                <Button color="success"><Icon
                                                                    style={{
                                                                        fontSize: 15,
                                                                        marginRight: "15%"
                                                                    }}>done</Icon>Added</Button>
                                                            </GridItem>
                                                            <GridItem xs={12} sm={6} md={6}>
                                                                <Button color="warning"
                                                                        onClick={this.CreateAlertForEdit}>Edit</Button>
                                                            </GridItem></GridContainer> </GridItem>) : (
                                                    <GridItem xs={12} sm={6} md={3}>
                                                        <Button color="warning" onClick={this.CreateAlert}>Add</Button>
                                                    </GridItem>) }
                                                <br />
                                            </GridContainer>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={6}>
                                            <legend>Services</legend>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <TagInputAutoSuggest
                                                    handleChangeServices={this.handleChangeServices.bind(this)}
                                                    services={this.state.services} role={this.state.roleClinic}
                                                    tagname="service"/>
                                            </GridItem>
                                        </GridItem>
                                        {isClinicMasterOrClinic() === "" && this.state.showDropdown ?
                                            <GridItem xs={12} sm={6} md={6}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="clinicmaster_id"
                                                        className={classes.selectLabel}>
                                                        Clinic Master
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.clinicmaster_id}
                                                        onChange={this.onChangeSelect}
                                                        inputProps={{
                                                            name: "clinicmaster_id",
                                                            id: "clinicmaster_id"
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disabled
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}>
                                                            Select Clinic
                                                        </MenuItem>
                                                        {clinicMasterList.map((x) => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             style={{height: "1.8em"}}
                                                                             value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <br />
                                            </GridItem> : null}
                                        {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                            <GridItem xs={12} sm={6} md={6}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="simple-select"
                                                        className={classes.selectLabel}>
                                                        Clinic
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.clinic_id}
                                                        onChange={this.onChangeSelect}
                                                        inputProps={{
                                                            name: "clinic_id",
                                                            id: "clinic_id"
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disabled
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}>
                                                            Select Clinic
                                                        </MenuItem>
                                                        {clinicsData.map((x) => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             style={{height: "1.8em"}}
                                                                             value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                <br />
                                            </GridItem> : null}
                                        <GridItem xs={12} sm={6} md={6}>
                                            <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}>
                                                <InputLabel
                                                    htmlFor="simple-select"
                                                    className={classes.selectLabel}>
                                                    Online Consultation
                                                </InputLabel>
                                                <Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    value={this.state.online}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "online",
                                                        id: "online"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                        classes={{
                                                            root: classes.selectMenuItem
                                                        }}>
                                                       Select  Consultation Type
                                                    </MenuItem>
                                                    <MenuItem
                                                              classes={{root: classes.selectMenuItem}}
                                                              style={{height: "1.8em"}}
                                                              value={"true"}>Online</MenuItem>
                                                    <MenuItem
                                                              classes={{root: classes.selectMenuItem}}
                                                              style={{height: "1.8em"}}
                                                              value={"false"}>Offline</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <br />
                                        </GridItem>
                                    </GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CustomInput
                                            labelText="Signature"
                                            success={this.state.signatureState === "success"}
                                            error={this.state.signatureState === "error"}
                                            id="experience"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "signature", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </form>
                            <CardFooter className={classes.justifyContentCenter}>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={6} md={2}>
                                        <Button block size="lg" color="warning" onClick={this.typeClick}>
                                            Save
                                        </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={2}>
                                        <NavLink to={dashboardRouter("/doctor/readDoctors")}>

                                            <Button block size="lg" color="grey">
                                                Cancel
                                            </Button></NavLink>
                                        <br />
                                    </GridItem>
                                </GridContainer>
                            </CardFooter>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

}

export default withStyles(validationFormsStyle, extendedFormsStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/DoctorForm/DoctorForm.jsx